import React from 'react'

import Client from './Client'
import Contact from './Contact'
import Driver from './Driver'
import Addresses from './Addresses'
import DateTimeRow from './DateTime'
import OrderClientID from './OrderClientID'
import Package from './Package'
import Payment from './Payment'
import Status from './Status'
import Priority from './Priority'
import Duration from './Duration'
import Eta from './Eta'

const Row = props => (
  <>
    <Priority {...props} />
    <OrderClientID {...props} />
    <DateTimeRow {...props} />
    <Package {...props} />
    <Client {...props} />
    <Addresses {...props} />
    <Duration {...props} />
    <Eta {...props} />
    <Contact {...props} />
    <Driver {...props} />
    <Status {...props} />
    <Payment {...props} />
  </>
)

export default React.memo(Row)
